(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wgc-mobile-shopping"]) return;
  try {
    
(function(){
  'use strict';
  function start(){
  var marker=document.getElementById('WgcMobileShopping'),enabled=!!marker;
  if(window.WgcMobileShoppingController)return;
  var small=window.matchMedia('(max-width:749px)'),origins=new Map(),tables=new Map(),pending=false;
  var body=document.body,main=document.getElementById('MainContent');
  body.classList.toggle('wgc-mobile-ui',enabled);
  function move(box,target){
    if(!box||!target||box.contains(document.activeElement))return;
    if(!origins.has(box)){
      if(!enabled||!small.matches)return;
      var origin=document.createElement('span');
      origin.hidden=true;origin.setAttribute('data-wgc-mobile-origin','');
      box.before(origin);origins.set(box,origin);
    }
    var anchor=enabled&&small.matches?target:origins.get(box);
    if(anchor.isConnected&&box.previousElementSibling!==anchor)anchor.after(box);
  }
  function rewards(){
    document.querySelectorAll('[data-section-type="product"]').forEach(function(section){
      var box=section.querySelector('[data-wgc-value][data-context="product"]');
      var form=section.querySelector('.product-single__meta form[action*="/cart/add"]');
      var target=form&&form.querySelector('.product-form__item--submit');
      move(box,target);
    });
    document.querySelectorAll('[data-section-type="cart-template"]').forEach(function(section){
      move(section.querySelector('[data-wgc-value][data-context="cart"]'),section.querySelector('.cart-update-note'));
    });
    origins.forEach(function(origin,box){if(!box.isConnected)origins.delete(box);});
  }
  function wrapTables(){
    if(!enabled){
      tables.forEach(function(state,table){if(state.region.isConnected)state.region.replaceWith(table);state.hint.remove();});
      tables.clear();return;
    }
    document.querySelectorAll('.product-single__description table').forEach(function(table){
      if(!small.matches&&!tables.has(table))return;
      if(!tables.has(table)){
        var region=document.createElement('div'),hint=document.createElement('p');
        region.className='wgc-mobile-table';region.setAttribute('role','region');
        region.setAttribute('aria-label',marker.dataset.tableLabel);
        hint.className='wgc-mobile-table-hint';hint.textContent=marker.dataset.tableHint;hint.hidden=true;
        table.before(hint,region);region.append(table);tables.set(table,{region:region,hint:hint});
      }
      var state=tables.get(table),overflow=state.region.scrollWidth>state.region.clientWidth+1;
      state.hint.hidden=!overflow;
      if(overflow)state.region.tabIndex=0;else state.region.removeAttribute('tabindex');
    });
    tables.forEach(function(state,table){if(!table.isConnected)tables.delete(table);});
  }
  function viewport(){
    if(!enabled){body.classList.remove('wgc-mobile-editing');return;}
    var vv=window.visualViewport;
    document.documentElement.style.setProperty('--wgc-mobile-vh',(vv?vv.height:window.innerHeight)+'px');
    document.documentElement.style.setProperty('--wgc-mobile-vtop',(vv?vv.offsetTop:0)+'px');
    var focused=document.activeElement;
    var editing=focused&&focused.matches('input:not([type="button"]):not([type="submit"]):not([type="checkbox"]):not([type="radio"]):not([type="range"]),textarea,select,[contenteditable="true"]');
    body.classList.toggle('wgc-mobile-editing',!!editing||!!(vv&&vv.scale>1.1));
  }
  function update(){
    pending=false;marker=document.getElementById('WgcMobileShopping');enabled=!!marker;
    body.classList.toggle('wgc-mobile-ui',enabled);viewport();rewards();wrapTables();
  }
  function schedule(){if(!pending){pending=true;requestAnimationFrame(update);}}
  window.WgcMobileShoppingController={refresh:schedule};
  window.addEventListener('resize',schedule,{passive:true});
  window.addEventListener('pageshow',schedule);
  document.addEventListener('focusin',schedule);
  document.addEventListener('focusout',schedule);
  document.addEventListener('shopify:section:load',schedule);
  document.addEventListener('shopify:section:unload',schedule);
  small.addEventListener('change',schedule);
  if(window.visualViewport){visualViewport.addEventListener('resize',schedule,{passive:true});visualViewport.addEventListener('scroll',schedule,{passive:true});}
  if(main)new MutationObserver(schedule).observe(main,{childList:true,subtree:true});
  update();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();

  } catch(e) { console.error(e); }
})();
})();
